<template>
  <ul :id="`tree-node-actions-${nodo.id}`">
    <li>
      <a
        class="a-tooltip-primary a-tooltip-bottom"
        :data-tooltip-text="$t('mEditionAssetContentsTreeNodeActions.actions.questions')"
        href="#"
        @click.prevent="selectNode"
      >
        <i :class="[nodo.id === $store.getters.getAssetSelectedNode.id
          ? 'text-color-assets-primary' : '', 'fas fa-question-circle']"></i>
      </a>
      <span
        v-if="nodo.total > 0"
        class="pending-number"
      >
        {{ nodo.total }}
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetContentsTreeNodeQuestions',

  props: {
    contenido: Object,
    nodo: Object
  },

  methods: {
    selectNode () {
      this.$store.commit('setAssetSelectedNode', this.nodo)
    }
  }
}
</script>
